import React from 'react'

import { ITank } from 'types'

interface IProps {
  tank: ITank
}

const _3dTank = ({ tank }: IProps) => {
  const info = tank.info
  let value = Math.round(parseFloat(info.value) * 100)

  if (value > 100) {
    value = 100
  } else if (value < 0) {
    value = 0
  }

  const top = -58
  const bot = 73
  const range = top - bot
  const fillh = (value / 100) * range * -1 + 24
  const y = (value / 100) * range + bot

  return (
    <svg width="100%" viewBox="0 0 200 210">
      <g transform="translate(100,100)">
        <rect x="-50" y="80" width="15" height="25" fill="#fff" strokeWidth="1px" stroke="#D2C49D" />
        <rect x="-7" y="80" width="15" height="20" fill="#EBE3CD" strokeWidth="1px" stroke="#D2C49D" />
        <rect x="35" y="80" width="15" height="25" fill="url(#tankGradient)" strokeWidth="1px" stroke="#D2C49D" />
        <ellipse cx="0" cy="70" rx="60" ry="15" fill="#fff" />
        <rect
          x="-60"
          y="-85"
          width="120"
          height="180"
          rx="60"
          ry="15"
          fill="url(#tankGradient)"
          strokeWidth="1px"
          stroke="#D2C49D"
        />
        <rect x="-50" y={y - 12} width="100" height={fillh} rx="55" ry="12" fill="url(#fillGradient)" />
        <ellipse cx="0" cy={y} rx="50" ry="12" fill="#81e0ff" />
        <text
          textAnchor="middle"
          fontSize="50px"
          fontWeight="bold"
          style={{ fill: 'rgb(130, 112, 102)' }}
          transform={`translate(${value < 10 ? -5 : value < 100 ? -10 : -13}, 25)`}
        >
          {value}
        </text>
        <text
          textAnchor="middle"
          fontSize="20px"
          fontWeight="bold"
          style={{ fill: 'rgb(130, 112, 102)' }}
          transform={`translate(${value < 10 ? 20 : value < 100 ? 30 : 38}, 10)`}
        >
          %
        </text>
      </g>
    </svg>
  )
}

export default _3dTank
